<template>
  <div class="limitInfo">
    <div class="head" v-if="Xtype!=1"><span @click="handleReturn" v-if="!title[2].status"></span>{{!title[1].status?title[0].name:!title[2].status?title[1].name:title[2].name}}</div>
    <div :class="[{main:Xtype==1},'infoTitle']">
      <div class="infoBox" v-for="(item,index) in title" :key="index">
        <div :class="[{'activeCircle':item.status},'circle']"><span></span></div>
        <div :class="[{'activeName':item.status},'name']">{{item.name}}</div>
      </div>
    </div>
    <template v-if="title[0].status && !title[1].status && !title[2].status">
      <div class="infoMain">
        <div class="companyInfo">
          <div>公司信息</div>
          <div class="companyType">认证类型（不可编辑）</div>
          <div class="companyPerson" v-if="type===1">个体</div>
          <div class="companyPerson" v-else>企业</div>
        </div>
        <div class="businessLicense">
          <div class="businessTitle">营业执照照片</div>
          <div>新办理的营业执照，因国家市场监督管理总局信息更新有延迟，建议在办理成功后等待至少14个工作日后再进行入驻</div>
          <div class="businessImg">
            <div class="businessPicture" @click="showPopup" v-if="param.storeSubjectInfo.licenseUrl===''">
              <img class="upload" src="../assets/image/camera.png" />
            </div>
            <div class="businessPicture" v-else>
              <img class="fileImg" :src="param.storeSubjectInfo.licenseUrl" />
              <img class="cutImg" @click="clickCutImg" src="../assets/image/cut.png" />
            </div>
            <van-popup v-model="popShow" round  closeable position="bottom" class="popup">
              <div class="popHead">上传照片示例</div>
              <div class="popImg"><img class="img" src="../assets/image/yImg.png" /></div>
              <div class="popTips">
                <div class="FirstTip">1.需提供三证合一的营业执照原件扫描件或加盖公司公章的复印件</div>
                <div class="FirstTip">2.确保未在企业经营异常名录中，且所售商品在营业执照经营范围内</div>
                <div class="FirstTip">3.营业执照有效期截止时间距今应大于3个月</div>
                <div class="FirstTip">4.露出证件四角，请勿遮挡或模糊，保持信息清晰可见</div>
                <div class="FirstTip">5.图片尺寸为800*800px以上，支持PNG、JPG和JPEG格式，大小不超过5M</div>
              </div>
              <div class="popFoot">
                <van-uploader
                  v-model="fileList"
                  :after-read="afterRead"
                  :preview-image="false"
                >
                <div class="popUp">上传照片</div>
                </van-uploader>
              </div>
            </van-popup>
          </div>
          <div :class="{changeColor:param.storeSubjectInfo.licenseUrl==='' && nextStatus}">上传营业执照照片</div>
        </div>
        <div class="input">
          <div class="verifyCode">
          <van-field
            v-model="param.storeSubjectInfo.company"
            name="公司名称"
            label="公司名称"
            placeholder='与营业执照“名称"处保持一致'
            placeholder-style="color:#BFBFBF"
            @click-input="clickInput1"
            @blur="clickBlur"
          />
          <img class="clear" v-if="clearStatus1" @click="clearText(1)" src="../assets/image/clear.png"/>
          </div>
          <div class="empty" v-if="param.storeSubjectInfo.company.trim()==='' && nextStatus">不能为空</div>
          <div class="verifyCode">
          <van-field
            v-model="param.storeSubjectInfo.socialCreditCode"
            name="统一社会信用代码"
            label="统一社会信用代码"
            placeholder='与营业执照“统一社会信用代码"处保持一致'
            placeholder-style="color:#BFBFBF"
            @click-input="clickInput2"
            @blur="clickBlur"
          />
          <img class="clear" v-if="clearStatus2" @click="clearText(2)" src="../assets/image/clear.png"/>
          </div>
          <div class="empty" v-if="param.storeSubjectInfo.socialCreditCode.trim()==='' && nextStatus">不能为空</div>
        </div>
        <div class="deadline">
          <div class="title">
            <span>营业期限</span>
            <span class="address">与营业执照“住所/经营场地"省市保持一致</span>
            <div class="longTime" @click="chooseTime">
              <img class="choose" :src="param.storeSubjectInfo.licenseLongTerm?require('../assets/image/chooseActive.png'):require('../assets/image/choose.png')" />
              <span>长期</span>
            </div>
          </div>
          <div class="time" v-if="!param.storeSubjectInfo.licenseLongTerm">
            <span :class="[{spanColor:param.storeSubjectInfo.licenseBegDay!=''}]" @click="licenseBegDay">{{param.storeSubjectInfo.licenseBegDay===''?'开始时间':param.storeSubjectInfo.licenseBegDay}}</span><span :class="[{spanColor:param.storeSubjectInfo.licenseEndDay!=''}]"> — </span><span :class="[{spanColor:param.storeSubjectInfo.licenseEndDay!=''}]" @click="licenseEndDay">{{param.storeSubjectInfo.licenseEndDay===''?'结束时间':param.storeSubjectInfo.licenseEndDay}}</span>
            <van-popup round position="bottom" v-model="BegDayStatus" :style="{ height: '50%' }">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="cancelBegDay"
                @confirm="confirmBegDay"
              />
            </van-popup>
            <van-popup round position="bottom" v-model="EndDayStatus" :style="{ height: '50%' }">
              <van-datetime-picker
                v-model="currentDate1"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="cancelEndDay"
                @confirm="confirmEndDay"
              />
            </van-popup>
          </div>
        </div>
        <div class="empty" v-if="!param.storeSubjectInfo.licenseLongTerm && nextStatus && param.storeSubjectInfo.licenseBegDay===''">不能为空</div>
        <div class="empty" v-else-if="!param.storeSubjectInfo.licenseLongTerm && nextStatus && param.storeSubjectInfo.licenseEndDay===''">不能为空</div>
        <div class="deadline">
          <div class="title">
            <span>公司注册地址</span>
          </div>
          <div class="time" @click="chooaseAddress">
            <img class="icon icon1" src="../assets/image/row.png"/>
            <div class="tip" v-if="param.storeSubjectInfo.companyRegisterArea===''">与营业执照“住所/经营场地"省市保持一致</div>
            <div class="tip tip1" v-else>{{param.storeSubjectInfo.companyRegisterArea}}</div>
          </div>
          <van-popup round position="bottom" v-model="addressShow" :style="{ height: '50%' }">
            <van-area title="标题" :area-list="areaList" :columns-num="2" @cancel="handleCancel" @confirm="handleConfirm" />
          </van-popup>
        </div>
        <div class="empty" v-if="param.storeSubjectInfo.companyRegisterArea==='' && nextStatus">不能为空</div>
      </div>
      <div class="infoMain">
        <div class="companyInfo">
          <template v-if="type===1">
            <div>经营者信息</div>
            <div class="companyType">经营者身份归属地</div>
          </template>
          <template v-else>
            <div>法定代表人信息</div>
            <div class="companyType">法定代表人身份归属地</div>
          </template>
          <div class="companyPerson" @click="chooseArea">{{areaName}} <img class="icon"  src="../assets/image/row.png"/></div>
          <van-action-sheet
            v-model="showSheet"
            :actions="actions"
            cancel-text="取消"
            close-on-click-action
            @cancel="onCancel"
            @select="selectArea"
          />
        </div>
        <div class="businessLicense">
          <div class="businessTitle">{{areaIndex==1?'身份证照片':areaIndex==3?'台湾同胞往来大陆通行证':areaIndex==5?'护照':'港澳居民往来内地通行证'}}</div>
          <div class="businessImgs">
            <div class="personInfo">
              <div v-if="param.storeSubjectInfo.holderIdFrontUrl===''">
                <img class="personInfoImg" @click="upInfoImg(0)" :src="areaIndex==1?require('../assets/image/infoZ.png'):require('../assets/image/info-01.png')" />
              </div>
              <div v-else>
                <img class="personInfoImg" :src="param.storeSubjectInfo.holderIdFrontUrl" />
                <img class="cutImg" @click.stop="delInfoImg" src="../assets/image/cut.png" />
              </div>
              <div :class="{changeColor:param.storeSubjectInfo.holderIdFrontUrl==='' && nextStatus}">{{areaIndex==1?'上传身份证人像面':areaIndex==5?'上传个人信息页':'上传证件人像面'}}</div>
            </div>
            <div class="personInfo1" v-if="areaIndex!=5">
              <div v-if="param.storeSubjectInfo.holderIdReverseUrl===''">
                <img class="personInfoImg"  @click="upInfoImg(1)" :src="areaIndex==1?require('../assets/image/infoF.png'):require('../assets/image/info-02.png')" />
              </div>
              <div v-else>
                <img class="personInfoImg" :src="param.storeSubjectInfo.holderIdReverseUrl" />
                <img class="cutImg" @click.stop="delInfoImg" src="../assets/image/cut.png" />
              </div>
              <div :class="{changeColor:param.storeSubjectInfo.holderIdReverseUrl==='' && nextStatus}">{{areaIndex==1?'上传身份证国徽面':'上传证件背面'}}</div>
            </div>
            <van-popup round position="bottom" v-model="infoShow"  closeable  class="popup">
              <div class="popHead">上传照片示例</div>
              <div class="popBox">
                <div class="boxHead">
                  <template v-if="sideIndex===0">
                    <img class="headImg" :src="areaIndex===1?require('../assets/image/frontInfo.png'):areaIndex===3?require('../assets/image/infoTW.png'):areaIndex===5?require('../assets/image/infoHZ.png'):require('../assets/image/infoXG.png')" />
                  </template>
                  <template v-else>
                    <img class="headImg" :src="areaIndex===1?require('../assets/image/infoND.png'):areaIndex===3?require('../assets/image/infoTW.png'):require('../assets/image/infoXG.png')" />
                  </template>
                  <div class="headTips">
                    <div class="First">
                      <img class="right" src="../assets/image/chooseActive.png"/>
                      <span>四角完整</span>
                    </div>
                    <div class="First">
                      <img class="right" src="../assets/image/chooseActive.png"/>
                      <span>亮度均匀</span>
                    </div>
                    <div class="First">
                      <img class="right" src="../assets/image/chooseActive.png"/>
                      <span>照片清晰</span>
                    </div>
                  </div>
                </div>
                <template v-if="sideIndex===0">
                  <img class="popImgList" :src="areaIndex===1?require('../assets/image/front.png'):areaIndex===3?require('../assets/image/frontTW.png'):areaIndex===5?require('../assets/image/frontHZ.png'):require('../assets/image/frontXG.png')" />
                </template>
                <template v-else>
                  <img class="popImgList" :src="areaIndex===1?require('../assets/image/frontND.png'):areaIndex===3?require('../assets/image/frontTW.png'):require('../assets/image/frontXG.png')" />
                </template>
                <div class="popLayout">证件文字能清晰辨认，勿遮挡或模糊，参考示例照片拍摄；格式JPG、PNG、JPEG，小于5M。</div>
              </div>
              <div class="popFoot">
                <van-uploader
                  v-model="fileList"
                  :after-read="afterReadInfo"
                  :preview-image="false"
                >
                <div class="popUp">上传照片</div>
                </van-uploader>
              </div>
            </van-popup>
          </div>
        </div>
        <div class="input">
          <div class="verifyCode">
          <van-field
            v-model="param.storeSubjectInfo.holderName"
            :name="type===1?'经营者姓名':'法定代表人姓名'"
            :label="type===1?'经营者姓名':'法定代表人姓名'"
            :placeholder="type===1?'请与营业执照“经营者”处保持一致':'请与营业执照“法定代表人”处保持一致'"
            placeholder-style="color:#BFBFBF"
            @click-input="clickInput3"
            @blur="clickBlur"
          />
          <img class="clear" v-if="clearStatus3" @click="clearText(3)" src="../assets/image/clear.png"/>
          </div>
          <div class="empty" v-if="param.storeSubjectInfo.holderName.trim()==='' && nextStatus">不能为空</div>
          <div class="verifyCode">
          <van-field
            v-model="param.storeSubjectInfo.holderIdNum"
            :name="type===1?'经营者身份证号码':'法定代表人身份证号码'"
            :label="type===1?'经营者身份证号码':'法定代表人身份证号码'"
            :placeholder="type===1?'与经营者姓名一致的身份证号码':'与法定代表人姓名一致的身份证号码'"
            placeholder-style="color:#BFBFBF"
            @click-input="clickInput4"
            @blur="clickBlur"
          />
          <img class="clear" v-if="clearStatus4" @click="clearText(4)" src="../assets/image/clear.png"/>
          </div>
          <div class="empty" v-if="param.storeSubjectInfo.holderIdNum.trim()==='' && nextStatus">不能为空</div>
        </div>
        <div class="deadline">
          <div class="title">
            <span>证件有效期</span>
            <div class="longTime">
              <img class="choose" :src="param.storeSubjectInfo.holderIdLongTerm?require('../assets/image/chooseActive.png'):require('../assets/image/choose.png')" @click="chooseTime1" />
              <span>长期</span>
            </div>
          </div>
          <div class="time" v-if="!param.storeSubjectInfo.holderIdLongTerm">
            <span :class="[{spanColor:param.storeSubjectInfo.holderIdBegDay!=''}]" @click="holderIdBegDay">{{param.storeSubjectInfo.holderIdBegDay===''?'开始时间':param.storeSubjectInfo.holderIdBegDay}}</span><span :class="[{spanColor:param.storeSubjectInfo.holderIdEndDay!=''}]"> — </span><span :class="[{spanColor:param.storeSubjectInfo.holderIdEndDay!=''}]" @click="holderIdEndDay">{{param.storeSubjectInfo.holderIdEndDay===''?'结束时间':param.storeSubjectInfo.holderIdEndDay}}</span>
            <van-popup round position="bottom" v-model="holderIdBegDayStatus" :style="{ height: '50%' }">
              <van-datetime-picker
                v-model="currentDate2"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="cancelholderIdBegDay"
                @confirm="confirmholderIdBegDay"
              />
            </van-popup>
            <van-popup round position="bottom" v-model="holderIdEndDayStatus" :style="{ height: '50%' }">
              <van-datetime-picker
                v-model="currentDate3"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="cancelholderIdEndDay"
                @confirm="confirmholderIdEndDay"
              />
            </van-popup>
          </div>
        </div>
        <div class="empty" v-if="!param.storeSubjectInfo.holderIdLongTerm && nextStatus && param.storeSubjectInfo.holderIdBegDay===''">不能为空</div>
        <div class="empty" v-else-if="!param.storeSubjectInfo.holderIdLongTerm && nextStatus && param.storeSubjectInfo.holderIdEndDay===''">不能为空</div>
      </div>
      <div class="foot">
        <span @click="nextStep">下一步</span>
      </div>
    </template>
    <template v-else-if="title[0].status && title[1].status && !title[2].status">
      <div class="infoMain">
        <div class="input">
          <div class="verifyCode">
          <van-field
            v-model="param.storeBasicInfo.shopName"
            name="店铺名称"
            label="店铺名称"
            placeholder='请输入店铺名称'
            placeholder-style="color:#BFBFBF"
            @click-input="clickInput5"
            @blur="clickBlur"
          />
           <img class="clear" v-if="clearStatus5" @click="clearText(5)" src="../assets/image/clear.png"/>
          </div>
        </div>
        <div class="empty" v-if="param.storeBasicInfo.shopName.trim()==='' && subStatus">不能为空</div>
        <div class="empty" v-if="shopNameMsg!='' && subStatus">{{this.shopNameMsg}}</div>
        <div class="businessLicense">
          <div class="businessTitle">店铺logo</div>
          <div class="businessImg" v-if="param.storeBasicInfo.avatarUrl===''">
            <van-uploader
            v-model="fileList"
            :after-read="afterReadLogo"
            :preview-image="false"
           >
            <div class="businessPicture">
              <img class="upload" src="../assets/image/camera.png" />
            </div>
            </van-uploader>
          </div>
          <div class="businessImg" v-else>
            <div class="businessPicture">
              <img class="fileImg" :src="param.storeBasicInfo.avatarUrl" />
              <img class="cutImg" @click="cleanLogoImg" src="../assets/image/cut.png" />
            </div>
          </div>
          <div :class="{changeColor:param.storeBasicInfo.avatarUrl==='' && subStatus}">请上传店铺logo</div>
        </div>
      </div>
      <div class="infoMain">
        <div class="companyInfo operatorInfo">
          <div>经营品类</div>
          <div class="operator" @click="chooseOperator">
            <div class="companyType">经营类目</div>
            <div class="companyClass"><span>选择类目</span><img class="icon"  src="../assets/image/row.png"/></div>
          </div>
          <template v-if="chooseList.length>0">
            <div class="chooseList">
              <div class="listItem" v-for="(list,lIndex) in chooseList" :key="lIndex">
                <span>{{list}}</span>
                <img class="icon" src="../assets/image/clear.png" @click="clearList(lIndex)" />
              </div>
            </div>
          </template>
          <van-popup round position="bottom" v-model="operatorShow"  class="popup">
            <template v-if="!searchStatus">
              <div class="operHead">
                <div class="cancle" @click="operatorCancle">取消</div>
                <div class="title">选择类目</div>
                <div class="affirm" @click="operatorAffirm">确定{{chooseNumber>0?'(已选'+chooseNumber+')':''}}</div>
                <div class="input" @click="handleSearch">
                  <img class="inputIcon" src="../assets/image/search.png"/>
                  <span>不知道类目？搜一搜</span>
                </div>
              </div>
              <div class="operaList">
                <van-collapse v-model="activeNames">
                  <van-collapse-item v-for="(item,index) in operaList" :key="index" :name="index">
                    <template #title>
                      <div>经营大类<span>{{item.name}}{{item.list.length>0?'（'+item.list.length+'）':""}}</span></div>
                    </template>
                    <div class="FirstOpera"><span class="oneClass">一级类目</span>
                      <div class="allChoose" @click="AllChoose(index)">
                        <img class="img" :src="item.chooseStatus?require('../assets/image/chooseActive.png'):require('../assets/image/choose.png')"/>
                        <span>全选</span>
                      </div>
                    </div>
                    <div class="operaType" v-for="(sub,subIndex) in item.childrens" :key="subIndex" @click="oneChoose(index,subIndex)">
                      <img class="typeImg" :src="sub.chooseStatus?require('../assets/image/chooseActive.png'):require('../assets/image/choose.png')"/>
                      <span>{{sub.name}}</span>
                    </div>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </template>
            <template v-else>
              <div class="popHead searchHead">
                <van-search
                  v-model="searchValue"
                  show-action
                  @search="searchConf"
                  @cancel="searchCancel"
                />
                <img class="inputLogo" src="../assets/image/search.png"/>
              </div>
              <div class="searchList" v-if="searchList.length>0">
                <div class="searchFirst" v-for="(item,index) in searchList" :key="index" @click="searchChoose(item)">
                  <img class="search" src="../assets/image/search.png"/>
                  <span>{{item.name}}</span>
                </div>
              </div>
              <div class="searchList" v-else>
                <img class="noData" src="../assets/image/noData.png"/>
              </div>
            </template>
          </van-popup>
          <div class="operatorTip">一级类目必须从营业执照允许的经营范围内选择，否则无法审核通过</div>
        </div>
        <div class="empty" v-if="chooseList.length===0 && subStatus">不能为空</div>
      </div>
      <div class="infoMain">
        <div class="operatorInfo">
          <div>店铺管理人信息</div>
        </div>
        <div class="input">
          <div class="verifyCode">
          <van-field
            v-model="param.storeBasicInfo.manager"
            name="管理人姓名"
            label="管理人姓名"
            placeholder='请输入管理人姓名'
            placeholder-style="color:#BFBFBF"
            @click-input="clickInput6"
            @blur="clickBlur"
          />
           <img class="clear" v-if="clearStatus6" @click="clearText(6)" src="../assets/image/clear.png"/>
          </div>
          <div class="empty" v-if="param.storeBasicInfo.manager.trim()==='' && subStatus">不能为空</div>
          <div class="verifyCode">
          <van-field
            v-model="param.storeBasicInfo.managerPhone"
            name="管理人手机号"
            type="number"
            label="管理人手机号"
            placeholder='请输入管理人手机号'
            placeholder-style="color:#BFBFBF"
            @click-input="clickInput7"
            @blur="clickBlur"
          />
          <img class="clear" v-if="clearStatus7" @click="clearText(7)" src="../assets/image/clear.png"/>
          </div>
          <div class="empty" v-if="param.storeBasicInfo.managerPhone.trim()==='' && subStatus">不能为空</div>
          <div class="verifyCode">
          <van-field
            v-model="param.storeBasicInfo.verifyCode"
            name="验证码"
            label="验证码"
            placeholder='请输入短信验证码'
            placeholder-style="color:#BFBFBF"
          />
            <div class="yzCode" @click="getCode" v-if="codeStatus">获取验证码</div>
            <div class="yzCode code" v-else>重新获取{{'('+count+')'}}</div>
          </div>
          <div class="empty" v-if="param.storeBasicInfo.verifyCode.trim()==='' && subStatus">不能为空</div>
        </div>
        <div class="successTip">小店开通成功后小店账号将与你登录的探店吃喝玩乐账号自动建立绑定关系，绑定关系建立后长期有效，不可随意解绑。小店账号只可与一个探店吃喝玩乐账号建立账号绑定关系。</div>
      </div>
      <div class="shopFoot">
        <div class="lastStep" @click="handleLastStep">上一步</div>
        <div class="lastStep submitAudit" @click="handleSubmitAudit">提交审核</div>
      </div>
    </template>
    <template v-else>
      <div class="auditInfo">
        <img class="auditImg" :src="isType===3?require('../assets/image/noPass.png'):require('../assets/image/audit.png')"/>
        <div class="auditSubmit">{{isType===3?'审核不通过':'申请已提交'}}</div>
        <div class="auditTip">{{isType===3?auditRemark:'平台约在1个工作日内完成审核，请您耐心等待'}}</div>
        <template v-if="isType===3">
          <div class="auditReturn" @click="reExamination">重新审核</div>
          <div class="auditReturn return" @click="returnMyShop">返回小店</div>
        </template>
        <template v-else>
          <div class="auditReturn" @click="returnMyShop">返回我的小店</div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import {picUpload,listBusinessScope,getVerifyCode,submitAudit,getByUser,submitAgain} from '@/api'
import { areaList } from '@vant/area-data';//
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      type:0,
      Xtype:null,//小程序传值去除顶部导航栏
      token:'',
      title:[{name:'主体信息',status:true},{name:'店铺信息',status:false},{name:'平台审核',status:false}],
      fileList: [],
      companyName:'',
      companyCode:'',
      date: '同营业执照“营业/经营期限"，若无则选长期',
      date1: '与身份证有效期保持一致',
      minDate: new Date(1980, 1, 1),
      maxDate: new Date(2050, 12, 31),
      currentDate: new Date(),
      currentDate1: new Date(),
      currentDate2: new Date(),
      currentDate3: new Date(),
      show: false,
      dataShow: false,
      showSheet: false,
      actions: [{name:'中国大陆',index:1},{name:'中国香港',index:2},{name:'中国台湾',index:3},{name:'中国澳门',index:4},{name:'海外',index:5}],
      areaName:'中国大陆',
      areaIndex:1,
      popShow:false,
      areaList,
      addressShow:false,
      infoShow:false,
      sideIndex:0,
      nextStatus:false,
      logoShow:false,
      operatorShow:false,
      activeNames: ['1'],
      operaList:[],
      opera:{
        name:'',
        page:1,
        pageSize:10
      },
      chooseList:[],
      chooseId:[],
      chooseNumber:0,
      subStatus:false,
      verifyCode:null,
      searchStatus:false,
      searchValue:'',
      searchList:[],
      shopNameMsg:'',
      BegDayStatus:false,
      EndDayStatus:false,
      holderIdBegDayStatus:false,
      holderIdEndDayStatus:false,
      codeStatus:true,
      count:60,
      param:{
        storeSubjectInfo: {
          company: "",//公司名称
          companyRegisterArea: "",//公司注册地址
          holderIdBegDay: "",//经营者证件有效开始日期 格式yyyy-MM-dd
          holderIdEndDay: "",//经营者证件有效结束日期 格式yyyy-MM-dd
          holderIdFrontUrl: "",//经营者证件正面链接 
          holderIdLongTerm: false,//经营者证件是否长期有效 1-是 0-否
          holderIdNum: "",//经营者证件号码
          holderIdReverseUrl: "",//经营者证件反面链接
          holderIdType: 1,//经营者身份归属地
          holderName: "",//经营者姓名
          licenseBegDay: "",//营业期限开始 格式yyyy-MM-dd
          licenseEndDay: "",//营业期限结束 格式yyyy-MM-dd
          licenseLongTerm: false,//营业执照是否长期 1-是 0-否
          licenseUrl: "",//营业执照图片链接
          socialCreditCode: "",//统一社会信用代码
          type: 1,//认证类型 1-个体 2-企业
        },
        storeBasicInfo:{
          auditRemark: "",//审核备注,不用填
          avatarUrl: "",//店铺logo
          businessScopeIds: "",//经营类目id,多个用逗号分隔
          id: 0,//初次申请不用填
          manager: "",//管理人姓名
          managerPhone: "",//管理人手机号
          shopName: "",//店铺名称
          shopNumber: "",//店铺号,初次申请不用填
          status: 0,//不用填
          verifyCode: "",//验证码
        }
      },
      clearStatus1:false,
      clearStatus2:false,
      clearStatus3:false,
      clearStatus4:false,
      clearStatus5:false,
      clearStatus6:false,
      clearStatus7:false,
      isType:0,
      auditRemark:'',
      scopeIds:[],
      again:false
    }
  },
  created(){
    console.log(wx)
    this.Xtype = sessionStorage.getItem('Xtype')
    if(this.Xtype==null || this.Xtype=='' || this.Xtype==isNaN){
      this.Xtype = Number(this.$route.query.Xtype)
      sessionStorage.setItem('Xtype',this.Xtype)
    }
    this.type = Number(this.$route.query.type)
    this.param.storeSubjectInfo.type = this.type
    this.isType = Number(this.$route.query.isType)
    if(this.isType==3){
      this.token = this.$route.query.token
      sessionStorage.setItem('token',this.token)
    }
    this.auditRemark = this.$route.query.auditRemark
    if(this.isType==1 || this.isType==3){
      this.title.forEach(item=>{
        item.status = true
      })
    }
    if(this.Xtype!=1){
      this.getTokenData()
    }
    this.getOperaData()// 获取经营类目列表
  },
  mounted () {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      window.getIosToken = this.getIosToken;
    }
  },
  methods: {
    getTokenData(){
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        window.webkit.messageHandlers.token.postMessage(null);
      }else if (navigator.userAgent.match(/android/i)) {
        window.android.getToken();
        this.token = window.android.getToken()
        sessionStorage.setItem('token',this.token)
        this.getByUserData()
      }
    },
    // ios获取token的方法
    getIosToken(token) {
      this.token = token
      sessionStorage.setItem('token',this.token)
      this.getByUserData()
    },
    handleReturn(){
      this.$router.go(-1)
    },
    returnMyShop(){
      // 调用原生方法
      setTimeout(()=>{
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.webkit.messageHandlers.popViewController.postMessage(null);
        } else if (navigator.userAgent.match(/android/i)) {
          window.android.appFinish();
        }
      }, 500)
      if(this.Xtype==1){
        wx.miniProgram.navigateBack({delta: 1})
      }
    },
    // 重新审核
    reExamination(){
      if(this.Xtype!=1){
        this.$router.push({ path:'/open-type'})
      }else{
        this.$router.push({ path:'/open-type?Xtype=1&token='+this.token})
      }
    },
    // 获取审核数据
    getByUserData(){
      this.getOperaData()
      getByUser().then(res=>{
        if(res.code==='200'){
          if(res.data.storeSubjectInfo.type==this.type){
            this.again = true
            this.param.storeSubjectInfo.company = res.data.storeSubjectInfo.company
            this.param.storeSubjectInfo.companyRegisterArea = res.data.storeSubjectInfo.companyRegisterArea
            this.param.storeSubjectInfo.holderIdBegDay = res.data.storeSubjectInfo.holderIdBegDay
            this.param.storeSubjectInfo.holderIdEndDay = res.data.storeSubjectInfo.holderIdEndDay
            this.param.storeSubjectInfo.holderIdFrontUrl = res.data.storeSubjectInfo.holderIdFrontUrl
            this.param.storeSubjectInfo.holderIdLongTerm = res.data.storeSubjectInfo.holderIdLongTerm
            this.param.storeSubjectInfo.holderIdNum = res.data.storeSubjectInfo.holderIdNum
            this.param.storeSubjectInfo.holderIdReverseUrl = res.data.storeSubjectInfo.holderIdReverseUrl
            this.param.storeSubjectInfo.holderIdType = res.data.storeSubjectInfo.holderIdType
            this.param.storeSubjectInfo.holderName = res.data.storeSubjectInfo.holderName
            this.param.storeSubjectInfo.licenseBegDay = res.data.storeSubjectInfo.licenseBegDay
            this.param.storeSubjectInfo.licenseEndDay = res.data.storeSubjectInfo.licenseEndDay
            this.param.storeSubjectInfo.licenseLongTerm = res.data.storeSubjectInfo.licenseLongTerm
            this.param.storeSubjectInfo.licenseUrl = res.data.storeSubjectInfo.licenseUrl
            this.param.storeSubjectInfo.socialCreditCode = res.data.storeSubjectInfo.socialCreditCode
            this.param.storeBasicInfo.auditRemark = res.data.storeBasicInfo.auditRemark
            this.param.storeBasicInfo.avatarUrl = res.data.storeBasicInfo.avatarUrl
            this.param.storeBasicInfo.id = res.data.storeBasicInfo.id
            this.param.storeBasicInfo.manager = res.data.storeBasicInfo.manager
            this.param.storeBasicInfo.managerPhone = res.data.storeBasicInfo.managerPhone
            this.param.storeBasicInfo.shopName = res.data.storeBasicInfo.shopName
            this.param.storeBasicInfo.shopNumber = res.data.storeBasicInfo.shopNumber
            this.param.storeBasicInfo.status = res.data.storeBasicInfo.status
            this.$nextTick(()=>{
              this.scopeIds = res.data.storeBasicInfo.businessScopeIds.split(",")
              this.chooseNumber = this.scopeIds.length
              this.operaList.forEach(item=>{
                item.childrens.forEach(e=>{
                  this.scopeIds.forEach(u=>{
                    if(e.id==u){
                      e.chooseStatus = true
                      this.chooseList.push(e.name)
                      item.list.push(e.name)
                      item.idList.push(u)
                      this.chooseId.push(u)
                    }
                  })
                })
              })
            })
          }
        }
      })
    },
    clickBlur(){
    },
    clickInput1(e){
      if(e.toElement.value.trim()!==''){
        this.clearStatus1 = true
      }
    },
    clickInput2(e){
      if(e.toElement.value.trim()!==''){
        this.clearStatus2 = true
      }
    },
    clickInput3(e){
      if(e.toElement.value.trim()!==''){
        this.clearStatus3 = true
      }
    },
    clickInput4(e){
      if(e.toElement.value.trim()!==''){
        this.clearStatus4 = true
      }
    },
    clickInput5(e){
      if(e.toElement.value.trim()!==''){
        this.clearStatus5 = true
      }
    },
    clickInput6(e){
      if(e.toElement.value.trim()!==''){
        this.clearStatus6 = true
      }
    },
    clickInput7(e){
      if(e.toElement.value.trim()!==''){
        this.clearStatus7 = true
      }
    },
    clearText(index){
      if(index===1){
        this.param.storeSubjectInfo.company = ''
        this.clearStatus1 = false
      }else if(index===2){
        this.param.storeSubjectInfo.socialCreditCode = ''
        this.clearStatus2 = false
      }else if(index===3){
        this.param.storeSubjectInfo.holderName = ''
        this.clearStatus3 = false
      }else if(index===4){
        this.param.storeSubjectInfo.holderIdNum = ''
        this.clearStatus4 = false
      }else if(index===5){
        this.param.storeBasicInfo.shopName = ''
        this.clearStatus5 = false
      }else if(index===6){
        this.param.storeBasicInfo.manager = ''
        this.clearStatus6 = false
      }else{
        this.param.storeBasicInfo.managerPhone = ''
        this.clearStatus7 = false
      }
    },
    // 打开弹窗--上传营业执照
    showPopup(){
      this.popShow = true
    },
    // 选择图片
    afterRead(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      this.$toast.loading({
         duration: 0, // 持续展示 toast
         forbidClick: true,
         message: "正在提交..."
      });
      picUpload(formData).then(res=>{
        this.$toast.clear()
        if(res.code==='200'){
          this.param.storeSubjectInfo.licenseUrl = res.data.url
          this.popShow = false
        }else{
          this.$toast(res.code)
        }
      })
    },
    // 清除图片
    clickCutImg(){
      this.param.storeSubjectInfo.licenseUrl = ''
    },
    // 打开弹窗--选择公司注册地址
    chooaseAddress(){
      this.addressShow = true
    },
    // 取消
    handleCancel(){
      this.addressShow = false
    },
    // 确认
    handleConfirm(e){
      this.param.storeSubjectInfo.companyRegisterArea = e[0].name +' - '+ e[1].name
      this.addressShow = false
    },
    // 上传身份证
    upInfoImg(index){
      this.sideIndex = index
      this.infoShow = true
    },
    // 证件图片路径
    afterReadInfo(file){
      const formData = new FormData();
      formData.append("file", file.file);
      this.$toast.loading({
         duration: 0, // 持续展示 toast
         forbidClick: true,
         message: "正在提交..."
      });
      picUpload(formData).then(res=>{
        this.$toast.clear()
        if(res.code==='200'){
          if(this.sideIndex===0){
            this.param.storeSubjectInfo.holderIdFrontUrl = res.data.url
          }else{
            this.param.storeSubjectInfo.holderIdReverseUrl = res.data.url
          }
          this.infoShow = false
        }
      })
    },
    // 清除证件照片
    delInfoImg(){
      if(this.sideIndex===0){
        this.param.storeSubjectInfo.holderIdFrontUrl = ''
      }else{
        this.param.storeSubjectInfo.holderIdReverseUrl = ''
      }
    },
    // 营业期限开始时间
    licenseBegDay(){
      this.BegDayStatus = true
    },
    // 取消
    cancelBegDay(){
      this.BegDayStatus = false
    },
    // 营业期限开始时间确认选择
    confirmBegDay(e){
      this.BegDayStatus = false
      const d = new Date(e)
      this.param.storeSubjectInfo.licenseBegDay = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' '
    },
    // 营业期限结束时间
    licenseEndDay(){
      this.EndDayStatus = true
    },
    // 取消
    cancelEndDay(){
      this.EndDayStatus = false
    },
    // 营业期限结束时间确认选择
    confirmEndDay(e){
      this.EndDayStatus = false
      const d = new Date(e)
      this.param.storeSubjectInfo.licenseEndDay = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' '
    },
    // 营业期限选择 -- 是否为长期
    chooseTime(){
      this.param.storeSubjectInfo.licenseLongTerm = !this.param.storeSubjectInfo.licenseLongTerm
      if(this.param.storeSubjectInfo.licenseLongTerm){
        this.param.storeSubjectInfo.licenseBegDay = ''
        this.param.storeSubjectInfo.licenseEndDay = ''
      }
    },
    // 经营者证件开始时间选择
    holderIdBegDay(){
      this.holderIdBegDayStatus = true
    },
    // 经营者证件结束时间选择
    holderIdEndDay(){
      this.holderIdEndDayStatus = true
    },
    // 开始时间--取消
    cancelholderIdBegDay(){
      this.holderIdBegDayStatus = false
    },
    // 结束时间--取消
    cancelholderIdEndDay(){
      this.holderIdEndDayStatus = false
    },
    // 经营者证件开始时间确认选择
    confirmholderIdBegDay(e){
      this.holderIdBegDayStatus = false
      const d = new Date(e)
      this.param.storeSubjectInfo.holderIdBegDay = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' '
    },
    // 经营者证件结束时间确认选择
    confirmholderIdEndDay(e){
      this.holderIdEndDayStatus = false
      const d = new Date(e)
      this.param.storeSubjectInfo.holderIdEndDay = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' '
    },
    // 经营者证件期限选择 -- 是否为长期
    chooseTime1(){
      this.param.storeSubjectInfo.holderIdLongTerm = !this.param.storeSubjectInfo.holderIdLongTerm
      if(this.param.storeSubjectInfo.holderIdLongTerm){
        this.param.storeSubjectInfo.holderIdBegDay = ''
        this.param.storeSubjectInfo.holderIdEndDay = ''
      }
    },
    // 地址选择
    chooseArea(){
      this.showSheet = true
    },
     // 地址选择
    selectArea(actions){
      this.areaName = actions.name
      this.areaIndex = actions.index
      this.param.storeSubjectInfo.holderIdType = actions.index
    },
    onCancel() {
      // Toast('取消');
    },
    // 下一步
    nextStep(){
      this.nextStatus = true
      if(this.param.storeSubjectInfo.company.trim()===''){
        return
      }else if(this.param.storeSubjectInfo.companyRegisterArea.trim()===''){
        return
      }else if(this.param.storeSubjectInfo.holderIdBegDay==='' && !this.param.storeSubjectInfo.holderIdLongTerm){
        return
      }else if(this.param.storeSubjectInfo.holderIdFrontUrl===''){
        return
      }else if(this.param.storeSubjectInfo.holderIdNum.trim()===''){
        return
      }else if(this.param.storeSubjectInfo.holderIdReverseUrl==='' && this.param.storeSubjectInfo.holderIdType!=5){
        return
      }else if(this.param.storeSubjectInfo.holderName.trim()===''){
        return
      }else if(this.param.storeSubjectInfo.licenseBegDay==='' && !this.param.storeSubjectInfo.licenseLongTerm){
        return
      }else if(this.param.storeSubjectInfo.licenseUrl===''){
        return
      }else if(this.param.storeSubjectInfo.socialCreditCode.trim()===''){
        return
      }else{
        this.title[1].status = true
      }
    },
    // Logo图片路径
    afterReadLogo(file){
      const formData = new FormData();
      formData.append("file", file.file);
      this.$toast.loading({
         duration: 0, // 持续展示 toast
         forbidClick: true,
         message: "正在提交..."
      });
      picUpload(formData).then(res=>{
        this.$toast.clear()
        if(res.code==='200'){
          this.param.storeBasicInfo.avatarUrl = res.data.url
        }
      })
    },
    // 清除Logo照片
    cleanLogoImg(){
      this.param.storeBasicInfo.avatarUrl = ''
    },
    // 经营类目--选择类目
    chooseOperator(){
      this.operatorShow = true
      this.searchStatus = false
      if(this.operaList.length===0){
        this.getOperaData()
      }else{
        this.operaList.forEach(item=>{
          if(item.list.length === item.childrens.length){
            item.chooseStatus = true
          }else{
            item.chooseStatus = false
          }
        })
      }
    },
    // 弹框--取消
    operatorCancle(){
      this.operatorShow = false
    },
    // 弹框--确认
    operatorAffirm(){
      this.chooseList = []
      this.chooseId = []
      this.operatorShow = false
      this.operaList.forEach(item=>{
        item.list.forEach(e=>{
          this.chooseList.push(e)
        })
        item.idList.forEach(e=>{
          this.chooseId.push(e)
        })
      })
    },
    // 获取经营类目列表
    getOperaData(){
      listBusinessScope(this.opera).then(res=>{
        if(res.code==='200'){
          res.data.records.forEach(item => {
            item.chooseStatus = false
            item.list = []
            item.idList = []
            item.childrens.forEach(e=>{
              e.chooseStatus = false
            })
          });
          this.operaList = res.data.records
        }
      })
    },
    // 全选
    AllChoose(index){
      this.operaList[index].list = []
      this.operaList[index].idList = []
      this.operaList[index].chooseStatus = !this.operaList[index].chooseStatus
      this.operaList[index].childrens.forEach(sub=>{
        if(this.operaList[index].chooseStatus){
          sub.chooseStatus = true
          this.operaList[index].list.push(sub.name)
          this.operaList[index].idList.push(sub.id)
        }else{
          sub.chooseStatus = false
          this.operaList[index].list = []
          this.operaList[index].idList = []
        }
      })
      this.chooseNumber = 0
      this.operaList.forEach(item=>{
        this.chooseNumber = this.chooseNumber+item.list.length
      })
    },
    // 单选
    oneChoose(index,subIndex){
      this.operaList[index].childrens[subIndex].chooseStatus = !this.operaList[index].childrens[subIndex].chooseStatus
      this.$nextTick(()=>{
        if(this.operaList[index].childrens[subIndex].chooseStatus){
          this.operaList[index].list.push(this.operaList[index].childrens[subIndex].name)
          this.operaList[index].idList.push(this.operaList[index].childrens[subIndex].id)
        }else{
          this.operaList[index].list.shift()
          this.operaList[index].idList.shift()
        }
        if(this.operaList[index].list.length === this.operaList[index].childrens.length){
          this.operaList[index].chooseStatus = true
        }else{
          this.operaList[index].chooseStatus = false
        }
        this.chooseNumber = 0
        this.operaList.forEach(item=>{
          this.chooseNumber = this.chooseNumber+item.list.length
        })
      })
    },
    // 删除
    clearList(lIndex){
      this.chooseNumber --
      this.chooseList.forEach((item,index)=>{
        if(lIndex===index){
          this.chooseList.splice(index,1)
          this.operaList.forEach(sub=>{
            sub.chooseStatus = false
            sub.list.forEach((f,d)=>{
              if(f===item){
                sub.list.splice(d,1)
              }
            })
            sub.childrens.forEach(e=>{
              if(e.name==item){
                e.chooseStatus = false
              }
            })
          })
        }
      })
      this.chooseId.forEach((a,adx)=>{
        if(lIndex===adx){
          this.chooseId.splice(adx,1)
          this.operaList.forEach((s,v)=>{
            s.childrens.forEach(k=>{
              if(k.id === a){
                s.idList.splice(v,1)
              }
            })
          })
        }
      })
    },
    // 搜索
    handleSearch(){
      this.searchStatus = true
    },
    // 输入搜索
    searchConf(val){
      this.searchList = []
      this.opera.name = val.trim()
      if(this.opera.name === ''){
        this.$toast('输入不能为空')
      }else{
        listBusinessScope(this.opera).then(res=>{
          if(res.code==='200'){
            res.data.records.forEach(item=>{
              item.childrens.forEach(e=>{
                this.searchList.push(e)
              })
            })
          }
        })
      }
    },
    // 取消
    searchCancel(){
      this.searchStatus = false
    },
    // 选中
    searchChoose(list){
      this.operaList.forEach(item=>{
        item.childrens.forEach(sub=>{
          if(sub.chooseStatus && sub.name===list.name){
            this.$toast('不能重复选中')
            return
          }else if(sub.name===list.name){
            this.chooseNumber ++
            sub.chooseStatus = true
            this.searchStatus = false
            if(item.id === list.pid){
              item.list.push(list.name)
              item.idList.push(list.id)
            }
            this.$nextTick(()=>{
              this.chooseList = []
              this.chooseId = []
              this.operaList.forEach(o=>{
                if(o.list.length===o.childrens.length){
                  o.chooseStatus = true
                }
                o.list.forEach(e=>{
                  this.chooseList.push(e)
                })
                o.idList.forEach(v=>{
                  this.chooseId.push(v)
                })
              })
            })
          }
        })
      })
      
    },
    // 上一步
    handleLastStep(){
      this.title[1].status = false
    },
    // 获取验证码
    getCode(){
      const accountReg  = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if(!accountReg.test(this.param.storeBasicInfo.managerPhone)){
				this.$toast('请输入正确的手机号码')
			}else{
        const form = {
          phone:this.param.storeBasicInfo.managerPhone
        }
        getVerifyCode(form).then(res=>{
          if(res.code==='200'){
            this.verifyCode = res.data
            this.codeStatus = false
            this.countDown()
          }else{
            this.$toast(res.msg)
          }
        })
      }
    },
    // 倒计时
    countDown(){
      this.count = 60
      let timmer = setInterval(()=>{
        this.count --
        if(this.count===0){
          clearInterval(timmer)
          this.codeStatus = true
        }
      },1000)
    },
    // 提交审核
    handleSubmitAudit(){
      this.subStatus = true
      let accountReg  = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      this.param.storeBasicInfo.businessScopeIds = this.chooseId.toString()
      if(this.param.storeBasicInfo.avatarUrl===''){
        return
      }else if(this.param.storeBasicInfo.businessScopeIds==='' && this.chooseId.length===0){
        return
      }else if(this.param.storeBasicInfo.manager.trim()===''){
        return
      }else if(this.param.storeBasicInfo.managerPhone.trim()===''){
        return
      }else if(!accountReg.test(this.param.storeBasicInfo.managerPhone)){
        this.$toast('请输入正确的手机号码')
      }else if(this.param.storeBasicInfo.shopName.trim()===''){
        return
      }else if(this.param.storeBasicInfo.verifyCode.trim()===''){
        return
      }else if(this.param.storeBasicInfo.verifyCode !==this.verifyCode){
        this.$toast('请输入正确的验证码')
      }else{
        if(!this.again){
          submitAudit(this.param).then(res=>{
            if(res.code==='200'){
              this.title[2].status = true
            }else if(res.code==='630042'){
              this.shopNameMsg = res.msg
            }else{
              this.$toast(res.msg)
            }
          })
        }else{
          submitAgain(this.param).then(res=>{
            if(res.code==='200'){
              this.title[2].status = true
            }else if(res.code==='630042'){
              this.shopNameMsg = res.msg
            }else{
              this.$toast(res.msg)
            }
          })
        }
      }
    },
  }
}
</script>
<style lang="scss">
.input{
  .van-cell{
    padding: .426667rem 0 .266667rem;
    flex-direction: column;
    font-size: .346667rem;
    color: #666666;
    border-bottom: 2px solid #E5E5E5;
  }
  .van-field__label{
    width: 100%;
  }
  .van-cell__value{
    font-size: .4rem;
  }
}
.time{
  .van-cell{
    padding: .426667rem 0 .266667rem;
    flex-direction: column;
    font-size: .346667rem;
    color: #666666;
  }
  .van-cell__title{
    font-size: .4rem;
    font-weight: 400;
    line-height: .586667rem;
    color: #BFBFBF;
  }
  .van-cell__value{
    text-align: left;
    font-size: .4rem;
    color: #BFBFBF;
  }
}
.van-popup--bottom.van-popup--round {
  border-radius: .213333rem .213333rem 0 0;
}
.van-popup__close-icon{
  font-size: .426667rem;
  position: fixed;
  top: 22%;
}
.van-uploader{
  width: 100%;
}
.van-uploader__input-wrapper{
  width: 100%;
}
.verifyCode{
  position: relative;
  .yzCode{
    position: absolute;
    right: 0;
    bottom: .4rem;
    z-index: 11;
    font-size: .4rem;
    font-weight: 400;
    line-height: .586667rem;
    color: #333333;
    &.code{
      color: #BFBFBF;
    }
  }
  .clear{
    position: absolute;
    right: 0;
    bottom: .4rem;
    z-index: 11;
    width: .426667rem;
    height: .426667rem;
  }
}
.popup{
  .van-cell{
    padding: .426667rem;
    font-size: .4rem;
    color: #999999;
  }
  .van-cell__title{
    color: #BFBFBF;
    span{
      color: #333333;
      margin-left: .24rem;
    }
  }
  .van-collapse-item__wrapper{
    height: auto;
    padding: 0;
    .van-collapse-item__content{
      padding: 0;
    }
  }
  .van-search{
    padding: 0;
    
    .van-search__action{
      color: #F3474A;
      padding: 0 0 0 .426667rem;
    }
    .van-search__content{
      background: #f8f8f8;
      height: 1.066667rem;
      border-radius: .106667rem;
      .van-cell{
        padding: 0;
        .van-field__left-icon{
          display: none;
        }
        .van-field__body{
          line-height: 1.066667rem;
          padding-left: .693333rem;
          i{
            display: none;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.limitInfo{
  .head{
    width: 100%;
    height: 1.173333rem;
    line-height: 1.173333rem;
    text-align: center;
    font-size: 0.453333rem;
    font-weight: bold;
    color: #333333;
    position: fixed;
    top: 0;
    background: #fff;
    z-index: 2200;
    span{
      width:0.64rem;
      height:0.64rem;
      background: url(../assets/image/back.png) no-repeat center;
      background-size: contain;
      display: inline-block;
      position: absolute;
      left: 0.426667rem;
      top: 0.266667rem;
    }
  }
  .infoTitle{
    margin-top: 1.173333rem;
    width: 100%;
    height: 1.866667rem;
    display: flex;
    &.main{
      margin-top: 0;
    }
    .infoBox{
      flex: 1;
      width: 1.28rem;
      height: auto;
      position: relative;
      &:not(:last-child)::before{
        content: '';
        position: absolute;
        top: .533333rem;
        left: 50%;
        width: 100%;
        height: 2px;
        background: #E5E5E5;
      }
      .circle{
        width: .453333rem;
        height: .453333rem;
        background: #F2F2F2;
        border-radius: 50%;
        margin: .32rem auto;
        position: relative;
        z-index: 1;
        &.activeCircle{
          background: #FFE1E1;
          span{
            background: #F3474A;
          }
        }
        span{
          display: inline-block;
          position: absolute;
          margin: .106667rem;
          width: .24rem;
          height: .24rem;
          background: #BFBFBF;
          border-radius: 50%;
        }
      }
      .name{
        display: block;
        text-align: center;
        font-size: .32rem;
        font-weight: 400;
        line-height: .453333rem;
        color: #9E9E9E;
        &.activeName{
          color: #3C3C3C;
        }
      }
    }
  }
  .infoMain{
    width: 100%;
    height: auto;
    background: #FFFFFF;
    padding: .32rem .426667rem;
    box-sizing: border-box;
    border-top: .213333rem solid #F8F8F8;
    .companyInfo{
      font-size: .346667rem;
      font-weight: 500;
      line-height: .48rem;
      color: #666666;
      border-bottom: 2px solid #E5E5E5;
      position: relative;
      &.operatorInfo{
        border-bottom: 0;
      }
      .companyType{
        margin: .64rem 0 .16rem;
      }
      .operator{
        display: flex;
        margin-bottom: .16rem;
        position: relative;
        .companyClass{
          position: absolute;
          right: 0;
          top:.64rem;
          span{
            margin-right: .373333rem;
          }
          .icon{
            position: absolute;
            width: .373333rem;
            height: .373333rem;
            right: 0;
            top: .026667rem;
          }
        }
      }
      .chooseList{
        .listItem{
          display: flex;
          flex-wrap: wrap;
          display: inline-block;
          height: .56rem;
          line-height: .56rem;
          background: #F2F2F2;
          border-radius: 4px;
          padding: 4px 8px;
          margin: 0 .266667rem .266667rem 0;
          position: relative;
          span{
            margin-right: .373333rem;
          }
          .icon{
            position: absolute;
            right: .106667rem;
            top: .16rem;
            width: .32rem;
            height: .32rem;
          }
        }
        
      }
      .operatorTip{
        font-size: .293333rem;
        font-weight: 400;
        line-height: .4rem;
        color: #999999;
        padding-top: 8px;
        border-top: 2px solid #E5E5E5;
      }
      .companyPerson{
        position: relative;
        font-size: .4rem;
        margin-bottom: .266667rem;
        .icon{
          position: absolute;
          right: 0;
          top: 0;
          width: .373333rem;
          height: .373333rem;
        }
      }
    }
    .businessLicense{
      padding-top: .426667rem;
      font-size: .293333rem;
      font-weight: 400;
      line-height: .4rem;
      color: #999999;
      .businessTitle{
        font-size: .346667rem;
        font-weight: 500;
        line-height: .48rem;
        color: #666666;
        margin-bottom: .16rem;
      }
      .businessImgs{
        display: flex;
        position: relative;
        .personInfo1{
          position: absolute;
          right: 0;
        }
        .personInfoImg{
          width: 4.093333rem;
          height: 2.693333rem;
          margin: .16rem 0;
        }
        .cutImg{
          position: absolute;
          z-index: 11;
          top: .16rem;
          left: 3.68rem;
          width: .373333rem;
          height: .373333rem;
        }
      }
      .businessImg{
        margin: .16rem 0;
      }
      .businessPicture{
        width: 4.053333rem;
        height: 2.666667rem;
        background: #E5E5E5;
        border-radius: .106667rem;
        position: relative;
        .upload{
          width: .746667rem;
          height: .746667rem;
          position: absolute;
          left: 50%;
          top: 37%;
          transform: translate(-50%)
        }
        .fileImg{
          width: 100%;
          height: 100%;
          border-radius: .106667rem;
        }
        .cutImg{
          position: absolute;
          z-index: 11;
          top: 0;
          right: 0;
          width: .373333rem;
          height: .373333rem;
        }
      }
    }
    .deadline{
      padding-top: .426667rem;
      padding-bottom: .266667rem;
      border-bottom: 2px solid #E5E5E5;
      .title{
        font-size: .346667rem;
        font-weight: 500;
        line-height: .48rem;
        color: #666666;
        position: relative;
        display: flex;
        .address{
          line-height: .56rem;
          font-size: .293333rem;
          margin-left: 8px;
          color: #999999;
        }
        .longTime{
          position: absolute;
          right: 0;
          display: flex;
          .choose{
            width: .533333rem;
            height: .533333rem;
          }
          span{
            line-height: .56rem;
            margin-left: 8px;
          }
        }
      }
      .time{
        position: relative;
        .icon{
          position: absolute;
          right: 0;
          top: .5rem;
          width: .373333rem;
          height: .373333rem;
          z-index: 11;
          &.icon1{
            top: 6px;
          }
        }
        .tip{
          margin-top: .5rem;
          font-size: .4rem;
          font-weight: 400;
          line-height: .586667rem;
          color: #BFBFBF;
          &.tip1{
            color: #333333;
          }
        }
        span{
          font-size: .4rem;
          font-weight: 400;
          line-height: .586667rem;
          color: #BFBFBF;
          &.spanColor{
            color: #333333;
          }
        }
      }
    }
    .successTip{
      font-size: .32rem;
      font-weight: 400;
      line-height: .453333rem;
      color: #999999;
      margin: .426667rem 0 .96rem;
    }
  }
  .shopFoot{
    width: 100%;
    height: 1.706667rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 0px rgba(153, 153, 153, 0.2);
    border-top: 1px solid #F8F8F8;
    display: flex;
    padding: .266667rem 0;
    box-sizing: border-box;
    position: relative;
    .lastStep{
      width: 4.48rem;
      height: 1.173333rem;
      line-height: 1.173333rem;
      border: .026667rem solid #999999;
      border-radius: .106667rem;
      margin-left: .426667rem;
      text-align: center;
      font-size: .4rem;
      font-weight: bold;
      color: #333333;
      &.submitAudit{
        position: absolute;
        border: 0;
        background: #F3474A;
        color: #fff;
        right: .426667rem;
      }
    }
  }
  .foot{
    border-top: .586667rem solid #F8F8F8;
    width: 100%;
    height: 1.706667rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 0px rgba(153, 153, 153, 0.2);
    span{
      display: block;
      width: 91.5%;
      height: 1.173333rem;
      background: #F3474A;
      border-radius: .213333rem;
      margin: .266667rem auto;
      font-size: .4rem;
      font-weight: bold;
      line-height: 1.173333rem;
      color: #FFFFFF;
      text-align: center;
    }
  }
  .auditInfo{
    margin-top: 1.84rem;
    text-align: center;
    .auditImg{
      width: 5.333333rem;
      height: 5.333333rem;
    }
    .auditSubmit{
      font-size: .64rem;
      font-weight: 400;
      line-height: .88rem;
      color: #F3474A;
      opacity: 0.8;
      margin: .64rem 0 .213333rem;
    }
    .auditTip{
      font-size: .373333rem;
      font-weight: 400;
      line-height: .533333rem;
      color: #999999;
      margin-bottom: .96rem;
    }
    .auditReturn{
      width: 80%;
      height: 1.173333rem;
      background: #F3474A;
      border-radius: .213333rem;
      font-size: .426667rem;
      font-weight: 400;
      line-height: 1.173333rem;
      color: #FFFFFF;
      text-align: center;
      margin: 0 auto .64rem;
      &.return{
        border: 2px solid #BFBFBF;
        color: #666666;
        background: #fff;
      }
    }
  }
  .popup{
    height: 80%;
    .popHead{
      width: 100%;
      height: 1.2rem;
      line-height: 1.2rem;
      text-align: center;
      font-size: .4rem;
      font-weight: 500;
      color: #3C3C3C;
      position: fixed;
      top: 20%;
      background: #FFFFFF;
      border-radius: .213333rem .213333rem 0 0;
      box-sizing: border-box;
      &.searchHead{
        height: 1.6rem;
        padding: .426667rem .426667rem 0 .426667rem;
      }
      .inputLogo{
        position: absolute;
        left: .746667rem;
        top: .746667rem;
        width: .426667rem;
        height: .426667rem;
      }
    }
    .popImg{
      width: 100%;
      height: auto;
      margin-top: 1.2rem;
      .img{
        width: 100%;
        height: 100%;
      }
    }
    .popTips{
      padding: .32rem .426667rem 0;
      box-sizing: border-box;
      height: auto;
      margin-bottom: 2rem;
      .FirstTip{
        font-size: .346667rem;
        font-weight: 400;
        line-height: .48rem;
        color: #666666;
        margin-bottom: .613333rem;
      }
    }
    .popFoot{
      width: 100%;
      height: 1.706667rem;
      position: fixed;
      bottom: 0;
      background: #FFFFFF;
      box-shadow: 0px 0px 0px rgba(153, 153, 153, 0.2);
      border-top: 1px solid #F8F8F8;
      z-index: 11;
      .popUp{
        width: 92%;
        height: 1.173333rem;
        background: #F3474A;
        border-radius: .213333rem;
        text-align: center;
        font-size: .4rem;
        font-weight: bold;
        line-height: 1.173333rem;
        color: #FFFFFF;
        margin: .266667rem 4%;
      }
    }
    .popBox{
      padding: .426667rem;
      margin-top: 1.2rem;
      box-sizing: border-box;
      .boxHead{
        display: flex;
        .headImg{
          width: 5.333333rem;
          height: 3.706667rem;
        }
        .headTips{
          margin: .666667rem 0 0 1.04rem;
          .First{
            display: flex;
            margin-bottom: .533333rem;
            .right{
              width: .426667rem;
              height: .426667rem;
              margin-right: .266667rem;
            }
            span{
              font-size: .373333rem;
              font-weight: 500;
              line-height: .426667rem;
              color: #333333;
            }
          }
        }
      }
      .popImgList{
        width: 100%;
        height: auto;
        margin: .426667rem 0 .32rem;
      }
      .popLayout{
        font-size: .346667rem;
        font-weight: 400;
        line-height: .48rem;
        color: #666666;
        margin-bottom: .666667rem;
      }
    }
    .operHead{
      width: 100%;
      height: 2.586667rem;
      font-size: .4rem;
      font-weight: 500;
      color: #3C3C3C;
      position: fixed;
      top: 20%;
      background: #FFFFFF;
      border-radius: .213333rem .213333rem 0 0;
      box-sizing: border-box;
      padding: .426667rem .426667rem 0 .426667rem;
      display: flex;
      z-index: 11;
      .cancle{
        position: absolute;
        left: .426667rem;
        top: .426667rem;
      }
      .title{
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        top: .426667rem;
      }
      .affirm{
        position: absolute;
        right: .426667rem;
        top: .426667rem;
        color: #F3474A;
      }
    }
    .input{
      width: 100%;
      height: 1.066667rem;
      line-height: 1.066667rem;
      background: #F8F8F8;
      border-radius: .106667rem;
      margin-top: .866667rem;
      position: relative;
      &.searchInput{
        width: 86.5%;
        margin:0;
      }
      .inputIcon{
        position: absolute;
        left: .32rem;
        top: .32rem;
        width: .426667rem;
        height: .426667rem;
      }
      span{
        font-size: .373333rem;
        font-weight: 400;
        color: #BFBFBF;
        margin-left: .96rem;
      }
    }
    .operaList{
      height: auto;
      margin-top: 2.586667rem;
      .FirstOpera{
        width: 100%;
        height: 1.12rem;
        line-height: 1.12rem;
        background: #F2F2F2;
        box-sizing: border-box;
        font-size: .346667rem;
        font-weight: 500;
        color: #666666;
        position: relative;
        .oneClass{
          margin-left: .426667rem;
        }
        .allChoose{
          position: absolute;
          right: .426667rem;
          width: 1.6rem;
          top: 0;
          .img{
            position: absolute;
            left: .213333rem;
            top: .293333rem;
            width: .426667rem;
            height: .426667rem;
          }
          span{
            font-weight: 400;
            margin-left: .8rem;
          }
        }
      }
      .operaType{
        width: 100%;
        height: 1.413333rem;
        line-height: 1.466667rem;
        background: #FFFFFF;
        display: flex;
        border-bottom: 1px solid #E5E5E5;
        .typeImg{
          width: .64rem;
          height: .64rem;
          margin: .4rem .213333rem .4rem .426667rem;
        }
        span{
          font-size: .4rem;
          font-weight: 400;
          color: #333333;
        }
      }
    }
    .searchList{
      margin-top: 1.6rem;
      height: auto;
      padding: 0 32px;
      position: relative;
      .searchFirst{
        height: 1.413333rem;
        line-height: 1.413333rem;
        border-bottom: 2px solid #E5E5E5;
        font-size: .4rem;
        font-weight: 400;
        color: #333333;
        position: relative;
        .search{
          width: .426667rem;
          height: .426667rem;
          position: absolute;
          left: 0;
          top: .48rem;
        }
        span{
          margin-left: .586667rem;
        }
      }
      .noData{
        width: 5.333333rem;
        height: 3.733333rem;
        position: absolute;
        left: 50%;
        top: 2.666667rem;
        transform: translate(-50%);
      }
    }
  }
  .empty{
    font-size: .346667rem;
    font-weight: 400;
    line-height: .48rem;
    color: #F3474A;
    margin-top: .106667rem;
  }
  .changeColor{
    color: #F3474A;
  }
}
</style>